import styled from 'styled-components';
import { JobsTableWrapperStyled } from 'Pages/JobsLibraryV2/JobsLibraryV2.styles';

// The wireframe's selection bar (#own-bar): "N selected" / the hint, then Transfer and Clear selection. Nothing in the
// app has this bar; everything else on the page reuses existing components and styles.
export const SelectionBarStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 12px;
  border: 1px solid #b3cdfb;
  border-radius: 6px;
  background: rgba(1, 85, 231, 0.08);
  color: #565e70;

  > :first-child {
    margin-right: auto;
  }
`;

// The parts around the table keep their height, so the table area (TableWrapperStyled, as on the Jobs Library page)
// takes the rest of the page and scrolls.
export const TabsBarStyled = styled.div`
  flex-shrink: 0;
  padding: 0 24px;

  .ant-tabs-nav {
    margin-bottom: 12px;
  }
`;

export const ControlsStyled = styled.div`
  flex-shrink: 0;
  padding: 0 24px;
`;

// The Jobs Library table wrapper, with rows at least two lines tall (a wrapped job title fits without the row growing,
// and short rows don't look cramped) and room between the job title and the owner.
export const TransferTableStyled = styled(JobsTableWrapperStyled)`
  .ant-table-tbody > tr > td {
    height: 60px;
  }

  .ant-table-thead > tr > th.ownership-col-title,
  .ant-table-tbody > tr > td.ownership-col-title {
    padding-right: 32px;
  }
`;
